import React from 'react';

import Unfulfilled from '../../components/unfulfilled';

const Map = () => {
    return <Unfulfilled />;
};

export default Map;
